import api from '@/api';

const revenue = id => api.get(`/internal/revenues/${id}`);
const payoutRecord = (id, payMode, page) =>
  api.get(
    `/internal/revenues/payout_record/${id}?pay_mode=${payMode}&page=${page}`
  );
const deleteRevenue = id => api.delete(`/internal/revenues/${id}`);

export {revenue, payoutRecord, deleteRevenue};
